import { render, staticRenderFns } from "./RouterTab.vue?vue&type=template&id=cbd9b69c&"
import script from "./RouterTab.js?vue&type=script&lang=js&"
export * from "./RouterTab.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports